export default __webpack_public_path__ + "static/media/partner-sponsor.c46377f6.jpg";